import queryString from 'query-string';

/*
 * Freemium detection for public auth flows (login/register/reset/unauthorized).
 *
 * Detection is based on the requesting Auth0 clientId being present in an
 * allowlist. Because the concrete production/QA clientIds are environment
 * specific (and not committed to this repo), the allowlist is sourced from:
 *   1. FREEMIUM_CLIENT_IDS below (compile-time constant), and
 *   2. window.REACT_APP_FREEMIUM_CLIENT_IDS (runtime, comma-separated) so the
 *      list can be maintained via environment configuration without a code
 *      change.
 *
 * When the allowlist is empty (the default), nothing is treated as freemium
 * and existing behavior is preserved.
 */

// Compile-time allowlist of freemium Auth0 clientIds. clientIds are public
// (they travel in every OIDC /authorize URL and are embedded in login HTML)
// so they are safe to commit. Runtime overrides via
// window.REACT_APP_FREEMIUM_CLIENT_IDS remain supported for local testing.
export const FREEMIUM_CLIENT_IDS = [
  'MHb9zi1XMBDbYQ9PGImMTIZw02bY1DRo',
  'Akl6KFp9ux7Yu2w32FT74VEFLJyciUXH',
  'TAk7tB1LJyVWgb8EDo91dMenxYfxI2YX',
  'CWxQqBgJsyYZEgGaxJ3YHICSmMDqE8wu',
];

// Unauthorized page messages that represent a freemium block.
export const FREEMIUM_UNAUTHORIZED_MESSAGES = [
  'freemium_login_blocked',
  'freemium_registration_blocked',
];

export const getFreemiumClientIds = () => {
  const runtime =
    (typeof window !== 'undefined' && window.REACT_APP_FREEMIUM_CLIENT_IDS) || '';
  const runtimeIds = runtime
    .split(',')
    .map(id => id.trim())
    .filter(Boolean);
  return [...FREEMIUM_CLIENT_IDS, ...runtimeIds];
};

export const isFreemiumClientId = (clientId) => {
  if (!clientId) {
    return false;
  }
  return getFreemiumClientIds().indexOf(clientId) !== -1;
};

// Be liberal in what we accept: callers may use different parameter casing.
export const getClientIdFromSearch = (search) => {
  const qs = queryString.parse(search || '');
  return qs.clientId || qs.clientid || qs.client_id || qs.clientID || null;
};

// True when the current request (identified by its query string) originates
// from a freemium client. Used to render a bare layout on public auth routes.
export const isFreemiumRequest = search => isFreemiumClientId(getClientIdFromSearch(search));

export const isFreemiumUnauthorizedMessage = message =>
  FREEMIUM_UNAUTHORIZED_MESSAGES.indexOf(message) !== -1;
